import { PermissionContainer } from '@views/components'
import React, { useState } from 'react'
import { View, StyleSheet } from 'react-native'
import BusinessAccountDrawer from './BusinessAccountDrawer'
import BusinessAccountInfo from './BusinessAccountInfo'

const BusinessAccountPage: React.FC = () => {
  const [issuedMemberCards, setIssuedMemberCards] = useState(false)
  const [depositsMade, setDepositsMade] = useState(false)

  return (
    <View style={styles.businessAccContainer}>
      <PermissionContainer>
        <BusinessAccountDrawer
          setIssuedMemberCards={setIssuedMemberCards}
          setDepositsMade={setDepositsMade}
        />
      </PermissionContainer>
      <BusinessAccountInfo issuedMemberCards={issuedMemberCards} depositsMade={depositsMade} />
    </View>
  )
}

const styles = StyleSheet.create({
  businessAccContainer: {
    flex: 1,
    alignItems: 'center',
    flexDirection: 'row',
  },
})

export default BusinessAccountPage
